"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
var classnames_1 = require("classnames");
var React = require("react");
var image_1 = require("wix-ui-core/image");
var Image_st_css_1 = require("./Image.st.css");
var Error_svg_1 = require("../../assets/icons/Error.svg");
var ImageUtils_1 = require("./ImageUtils");
var RelativeMediaImage_1 = require("./RelativeMediaImage");
var Text_1 = require("../Text");
var types_1 = require("./types");
/** Image is a component to literally display an image - whether an absolute with full URL or a media platform item with relative URI */
var Image = /** @class */ (function (_super) {
    __extends(Image, _super);
    function Image() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isLoaded: false, boundingRectDimensions: null, isError: false };
        _this.containerRef = React.createRef();
        _this.imageRef = React.createRef();
        _this._onLoad = function (event) {
            var onLoad = _this.props.onLoad;
            if (!_this.state.isLoaded) {
                _this.setState({ isLoaded: true });
            }
            onLoad && onLoad(event);
        };
        _this._onError = function (event) {
            var onError = _this.props.onError;
            if (!_this.state.isError) {
                _this.setState({ isError: true });
            }
            onError && onError(event);
        };
        return _this;
    }
    Image.prototype.componentDidMount = function () {
        var _a;
        var _b = this.props, width = _b.width, height = _b.height, aspectRatio = _b.aspectRatio;
        var imageElement = this.imageRef.current;
        // Updating the state in case it's rendered with SSR and the image is loaded on the client even before registering the `onLoad` event
        if (!this.state.isLoaded && (imageElement === null || imageElement === void 0 ? void 0 : imageElement.complete)) {
            this.setState({ isLoaded: true });
        }
        // Updating the state only if we don't have enough information to calculate the dimensions
        if (!(width && height) && !((width || height) && aspectRatio)) {
            var _c = (_a = this.containerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect(), boundingRectWidth = _c.width, boundingRectHeight = _c.height;
            this.setState({
                boundingRectDimensions: {
                    width: boundingRectWidth,
                    height: boundingRectHeight,
                },
            });
        }
    };
    Image.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, src = _b.src, width = _b.width, height = _b.height, onLoad = _b.onLoad, onError = _b.onError, aspectRatio = _b.aspectRatio, resize = _b.resize, focalPoint = _b.focalPoint, fluid = _b.fluid, hoverEffect = _b.hoverEffect, loadingBehavior = _b.loadingBehavior, errorMessage = _b.errorMessage, imageProps = __rest(_b, ["className", "src", "width", "height", "onLoad", "onError", "aspectRatio", "resize", "focalPoint", "fluid", "hoverEffect", "loadingBehavior", "errorMessage"]);
        var _c = this.state, isLoaded = _c.isLoaded, boundingRectDimensions = _c.boundingRectDimensions, isError = _c.isError;
        var isAbsoluteUrl = src && src.match('^https?://');
        var aspectRatioAsNumber = typeof aspectRatio === 'number'
            ? aspectRatio
            : types_1.AspectRatioPresets[aspectRatio];
        // Taking the dimensions from props or from its bounding rectangle in case they're missing
        var sourceDimensions = {
            width: width || (boundingRectDimensions === null || boundingRectDimensions === void 0 ? void 0 : boundingRectDimensions.width),
            height: height || (boundingRectDimensions === null || boundingRectDimensions === void 0 ? void 0 : boundingRectDimensions.height),
        };
        // Calculating the dimensions considering the given values and aspect ratio
        var calculatedDimensions = ImageUtils_1.calculateDimensions(__assign(__assign({}, sourceDimensions), { aspectRatio: aspectRatioAsNumber }));
        var focalPointCoordinates = focalPoint && ImageUtils_1.resolveFocalPointCoordinates(focalPoint);
        var hasLoadingBehavior = loadingBehavior === types_1.LoadingBehaviorOptions.blur;
        return (React.createElement("div", __assign({ ref: this.containerRef, className: Image_st_css_1.st(Image_st_css_1.classes.root, resize === types_1.ResizeOptions.cover ? Image_st_css_1.classes.cover : Image_st_css_1.classes.contain, classnames_1.default(className, (_a = {},
                _a[Image_st_css_1.classes.fluid] = fluid,
                _a[Image_st_css_1.classes.zoom] = hoverEffect === types_1.HoverEffectOptions.zoom,
                _a[Image_st_css_1.classes.darken] = hoverEffect === types_1.HoverEffectOptions.darken,
                _a[Image_st_css_1.classes.preload] = hasLoadingBehavior && !isLoaded,
                _a[Image_st_css_1.classes.loaded] = hasLoadingBehavior && isLoaded,
                _a[Image_st_css_1.classes.isError] = isError,
                _a))) }, (!fluid && {
            style: {
                // If fixed dimensions were passed, we set the calculated values to fit the container with the fixed image
                width: width && (calculatedDimensions === null || calculatedDimensions === void 0 ? void 0 : calculatedDimensions.width),
                height: height && (calculatedDimensions === null || calculatedDimensions === void 0 ? void 0 : calculatedDimensions.height),
            },
        }), { "data-hook": this.props['data-hook'] }),
            isAbsoluteUrl ? (React.createElement(image_1.Image, __assign({ src: src, className: Image_st_css_1.classes.image }, (calculatedDimensions && {
                nativeProps: __assign(__assign({}, calculatedDimensions), (focalPointCoordinates && {
                    style: {
                        objectPosition: focalPointCoordinates.x + "% " + focalPointCoordinates.y + "%",
                    },
                })),
            }), { nativeRef: this.imageRef, onLoad: this._onLoad, onError: this._onError }, imageProps))) : (React.createElement(RelativeMediaImage_1.RelativeMediaImage, __assign({ src: src, className: Image_st_css_1.classes.image, sourceDimensions: sourceDimensions, containerDimensions: calculatedDimensions, focalPoint: focalPointCoordinates, isPlaceholderDisplayed: hasLoadingBehavior && !isLoaded, nativeRef: this.imageRef, onLoad: this._onLoad, onError: this._onError }, imageProps))),
            isError && (React.createElement("div", { className: Image_st_css_1.classes.errorWrapper, "aria-hidden": "true" },
                React.createElement(Error_svg_1.ReactComponent, { className: Image_st_css_1.classes.errorIcon }),
                React.createElement(Text_1.Text, { className: Image_st_css_1.classes.errorMessage }, errorMessage)))));
    };
    Image.displayName = 'Image';
    Image.defaultProps = {
        resize: types_1.ResizeOptions.contain,
        errorMessage: 'Image not found',
    };
    return Image;
}(React.Component));
exports.Image = Image;
//# sourceMappingURL=Image.js.map